import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/gp";

const COLUMNS = [
  {
    title: "Play",
    links: [
      { label: "Yorick chat", to: "/chat" },
      { label: "Tournaments", to: "/tournaments" },
      { label: "Leaderboard", to: "/leaderboard" },
      { label: "Calendar", to: "/calendar" },
    ],
  },
  {
    title: "Balatro",
    links: [
      { label: "Balatro hub", to: "/balatro" },
      { label: "Beginner guide", to: "/balatro/beginner-guide" },
      { label: "News", to: "/news" },
      { label: "Rules", to: "/rules" },
    ],
  },
  {
    title: "Account",
    links: [
      { label: "Sign in", to: "/login" },
      { label: "Pricing", to: "/pricing" },
      { label: "Support", to: "/support" },
      { label: "Privacy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
      { label: "Cookies", to: "/cookies" },
      { label: "Refunds", to: "/refunds" },
      { label: "Community rules", to: "/community" },
      { label: "Refer a friend", to: "/refer" },
    ],
  },
];
export default function Footer() {
  return (
    <footer className="relative z-10 bg-gp-deep border-t border-white/10 mt-20" data-testid="footer">
      <div className="mx-auto max-w-[1440px] px-5 md:px-8 py-16 md:py-20 grid gap-12 md:grid-cols-5">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="GamePlat" className="h-10 w-10 rounded-lg object-cover ring-1 ring-white/15" />
            <span className="font-unbounded font-black tracking-tighter text-2xl">
              Game<span className="text-gp-gold">Plat</span>
            </span>
          </Link>
          <p className="mt-4 text-white/60 max-w-sm leading-relaxed">
            Meet Yorick — Balatro strategy coach and community mascot. Guides, a free contest waitlist for December 12, 2026, and answers players are actually searching.
          </p>
          <Link
            to="/tournaments"
            data-testid="footer-waitlist"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-gp-blue/40 bg-gp-blue/10 px-4 py-2 text-sm font-semibold text-gp-blue hover:bg-gp-blue/20 transition-colors"
          >
            Join the December 12 waitlist
          </Link>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title}>
            <h4 className="font-vt323 uppercase tracking-widest text-lg text-gp-blue">{col.title}</h4>
            <ul className="mt-4 space-y-3">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/60 hover:text-white transition-colors text-sm"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1440px] px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/40">
          <p>© {new Date().getFullYear()} GamePlatPlay™. Independent platform; game names belong to their respective owners.</p>
          <p className="font-vt323 tracking-widest text-gp-muted">HOW CAN I HELP YOU WIN?</p>
        </div>
      </div>
    </footer>
  );
}
